// Import Required Libraries
import React, { useEffect, useState } from "react";
import { Switch, Route, HashRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { updateSourceInputs } from "../redux/actions";

// Import Pages
import Login from "../screens/Login/Login";
import Unauthorised from "../screens/Unauthorised/Unauthorised";
import PageNotFound from "../screens/PageNotFound/PageNotFound";
import AttributeEnrichment from "../screens/Mapping/AttributeEnrichment/AttributeEnrichment";
import TemplateView from "../screens/Mapping/TemplateMapping/TemplateView";
import RetailView from "../screens/Mapping/RetailerMapping/RetailView";
import RGMRetailView from "../screens/Mapping/RgmRetailerMapping/RGMRetailView";
import GoldTemplateView from "../screens/Mapping/GoldTemplateMapping/GoldTemplateView";
import LocalReporting from "../screens/Mapping/LocalReporting/LocalReporting";
import LocalReportingAM from "../screens/Mapping/LocalReporting/AttributeMapping/LocalReportingAM";
import LocalReportingPPB from "../screens/Mapping/LocalReporting/PillerPowerBrandMapping/LocalReportingPPB";
import LocalReportingUS from "../screens/Mapping/LocalReporting/UsMappings/LocalReportingUS";
import ProductMapping from "../screens/Mapping/ProductMapping/ProductMapping";
import AdminView from "../screens/Mapping/AdminControls/AdminView";
import UsersView from "../screens/Mapping/AdminControls/Users/UsersView";
import RolesView from "../screens/Mapping/AdminControls/Roles/RolesView";
import ProductMappingView from "../screens/Mapping/AdminControls/Usecases/ProductMapping/ProductMappingView";
import GlobalRetailerMappingView from "../screens/Mapping/AdminControls/Usecases/GlobalRetailerMapping/GlobalRetailerMappingView";
import RetailerMappingView from "../screens/Mapping/AdminControls/Usecases/RetailerMapping/RetailerMappingView";
import SilverTemplateMappingView from "../screens/Mapping/AdminControls/Usecases/SilverTemplateMapping/SilverTemplateMappingView";
import GoldTemplateMappingView from "../screens/Mapping/AdminControls/Usecases/GoldTemplateMapping/GoldTemplateMappingView";
import AttributeEnrichmentView from "../screens/Mapping/AdminControls/Usecases/AttributeEnrichment/AttributeEnrichmentView";
import LocalReportingView from "../screens/Mapping/AdminControls/Usecases/LocalReporting/LocalReportingView";

// Redux
import { updateUserDetails } from "../redux/actions";
import sidenavData from "../../assets/data/sidenavData.json";
import Loader from "../components/Loader/Loader";
import HomePage from "../screens/HomePage";

function Routes(props) {
  const [user_restriction, setuser_restriction] = useState([]);
  const [loadingRoutes, setLoadingRoutes] = useState(true);

  function getUserRestriction() {
    if (
      props.user_detail &&
      props.user_detail.user_info &&
      Array.isArray(props.user_detail.user_info.allowed_sidenav) &&
      props.user_detail.user_info.allowed_sidenav.length > 0
    ) {
      const Main_Routes = props?.user_detail?.user_info?.allowed_sidenav;
      const SORTED_MAIN_ROUTES =
        Main_Routes?.filter((item) => item.id !== "harbor/local_reporting") ??
        [];

      // SUB ROUTES FOR LOCAL REPORTING USECASE
      const Side_Nav_Routes = Main_Routes?.find(
        (item) => item.is_sidenav && !Array.isArray(item?.sidenav_details),
      );
      const Side_Nav_Category =
        Side_Nav_Routes?.sidenav_details?.sidebar_details || [];
      const Usecases = Side_Nav_Routes?.sidenav_details?.usecases || [];

      let UsecasesSubRouteList = [];
      Side_Nav_Category?.forEach((mainItem) => {
        UsecasesSubRouteList = [
          ...UsecasesSubRouteList,
          ...(Usecases?.[mainItem.value] || []),
        ];
      });

      const FinalUsecaseSideNavRoutes = UsecasesSubRouteList?.map(
        (sideNavItem) => {
          return {
            id: `harbor/${Side_Nav_Routes?.value || "local_reporting"}/${sideNavItem.value}`,
            name: sideNavItem.label,
            materialUiIconName: sideNavItem.materialUiIconName,
            materialUiClassName: "material-icons-outlined",
            specialStyling: false,
            component: sideNavItem.component,
            app_name: "Harbor",
            is_sidenav: false,
            sidenav_details: {},
          };
        },
      );

      // SUB ROUTES OF ADMIN CONTROL SCREEN
      const Admin_Side_Nav_Routes = Main_Routes?.find(
        (item) => item.is_sidenav && Array.isArray(item?.sidenav_details),
      );
      const AdminSubRoutesList = Admin_Side_Nav_Routes?.sidenav_details || [];

      const FinalAdminSideNavRoutes = AdminSubRoutesList?.map((sideNavItem) => {
        return {
          id: `harbor/${Admin_Side_Nav_Routes?.value || "admin_controls"}/${sideNavItem.value}`,
          name: sideNavItem.label,
          materialUiIconName: sideNavItem.materialUiIconName,
          materialUiClassName: "material-icons-outlined",
          specialStyling: false,
          component: sideNavItem.component,
          app_name: "Harbor",
          is_sidenav: false,
          sidenav_details: {},
        };
      });

      const Final_Allowed_Routes = [
        ...SORTED_MAIN_ROUTES,
        ...FinalUsecaseSideNavRoutes,
        ...FinalAdminSideNavRoutes,
      ];
      props.updateSourceInputs("screens", Final_Allowed_Routes);
      setuser_restriction(Final_Allowed_Routes);
    } else {
      const Main_Routes = sidenavData || [];
      const SORTED_MAIN_ROUTES =
        Main_Routes?.filter((item) => item.id !== "harbor/local_reporting") ??
        [];
      const Side_Nav_Routes = sidenavData?.find((item) => item.is_sidenav);

      const Side_Nav_Category =
        Side_Nav_Routes?.sidenav_details?.sidebar_details || [];
      const Usecases = Side_Nav_Routes?.sidenav_details?.usecases || [];

      let AllRoutes = [];
      Side_Nav_Category?.forEach((mainItem) => {
        AllRoutes = [...AllRoutes, ...(Usecases?.[mainItem.value] || [])];
      });

      const FinalSideNavRoutes = AllRoutes?.map((sideNavItem) => {
        return {
          id: `harbor/local_reporting/${sideNavItem.value}`,
          name: sideNavItem.label,
          materialUiIconName: sideNavItem.materialUiIconName,
          materialUiClassName: "material-icons-outlined",
          specialStyling: false,
          component: sideNavItem.component,
          app_name: "Harbor",
          is_sidenav: false,
          sidenav_details: {},
        };
      });

      const Final_Allowed_Routes = [
        ...SORTED_MAIN_ROUTES,
        ...FinalSideNavRoutes,
      ];
      props.updateSourceInputs("screens", Final_Allowed_Routes);
      // setuser_restriction(Final_Allowed_Routes);
      setuser_restriction([]);
    }
    setLoadingRoutes(false);
  }

  useEffect(() => {
    getUserRestriction();
  }, [props.user_detail, props.user_detail.user_info]);

  const componentMap = {
    AttributeEnrichment,
    TemplateView,
    GoldTemplateView,
    RetailView,
    RGMRetailView,
    LocalReporting,
    LocalReportingAM,
    LocalReportingPPB,
    LocalReportingUS,
    ProductMapping,
    AdminView,
    UsersView,
    RolesView,
    ProductMappingView,
    GlobalRetailerMappingView,
    RetailerMappingView,
    SilverTemplateMappingView,
    GoldTemplateMappingView,
    AttributeEnrichmentView,
    LocalReportingView,
  };

  return (
    <HashRouter>
      {loadingRoutes ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            backgroundColor: "#f8f9fa",
          }}
        >
          <Loader />
          <p style={{ marginTop: "15px", fontSize: "16px", color: "#333" }}>
            Successfully signed in. Please wait while we redirect you...
          </p>
        </div>
      ) : (
        <Switch>
          {/* Render all sidenav routes */}
          {user_restriction &&
            user_restriction.length > 0 &&
            user_restriction.map((route, index) => {
              const Component = componentMap[route.component];
              return (
                <Route
                  key={index}
                  path={`/${route.id}`}
                  component={Component}
                  exact
                />
              );
            })}

          <Route path="/harbor/home" component={HomePage} exact />
          <Route exact path="/harbor">
            <Redirect to={`/harbor/home`} />
          </Route>

          <Route exact path="/">
            <Redirect to={`/harbor/home`} />
          </Route>
          <Route path="/login" component={Login} exact />
          <Route path="/unauthorised" component={Unauthorised} exact />
          <Route component={PageNotFound} />
        </Switch>
      )}
    </HashRouter>
  );
}

const mapStateToProps = (state) => ({
  user_detail: state.user_detail,
});

const mapDispatchToProps = {
  updateUserDetails,
  updateSourceInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
